import React from 'react';
import { BoldBodyText, FlexRow, Grid, SeeMoreLessBlock, SeeMoreLessSize, UserIconStyled } from 'ui-toolkit';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';
import SpruceIcon from 'ui-toolkit/images/spruce-icon-big.png';
import ZillowIcon from 'ui-toolkit/images/zillow-icon-big.png';
import styled from 'styled-components';
import { ICommentData } from '../../../types/order/comment/IComment';
import { eAuthorType } from '../../../types/order/comment/eAuthorTypes';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

export const CommentContent: React.FC<{ comment: ICommentData }> = ({ comment: { author, content, createdAt } }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const authorInitials = author.fullName.split(' ').reduce((a, b) => a + b.charAt(0), '');
  const adminIcon = isZillowClosingEnabled ? ZillowIcon : SpruceIcon;
  const altText = isZillowClosingEnabled ? 'zillow-icon' : 'spruce-icon';

  return (
    <Grid templateColumns={'min-content 1fr'}>
      <UserIconStyled>
        {author.type === eAuthorType.Admin ? <AdminLogo src={adminIcon} alt={altText} /> : <>{authorInitials}</>}
      </UserIconStyled>
      <Grid>
        <FlexRow justifyContent={'space-between'}>
          <BoldBodyText>{author.fullName}</BoldBodyText>
          <BoldBodyText>{getDateString(DateFormat.longDateTime, createdAt, true)}</BoldBodyText>
        </FlexRow>
        <SeeMoreLessBlock maxHeight={SeeMoreLessSize.small}>{content}</SeeMoreLessBlock>
      </Grid>
    </Grid>
  );
};

const AdminLogo = styled.img`
  height: 100%;
  width: 100%;
`;
